import DataTableToolbar from "@components/data_table_toolbar"
import GridTable from "@components/grid-table"
import { GRAY_COLOR, WATSAPP_ACTIVE } from "@constants/colors"
import { useWhatsappPageContext } from "@contexts/main/whatsapp_page_context"
import { Stack } from "@mui/material"
import Box from "@mui/material/Box"
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid"
import { formatDate } from "@utils/functions/formatDate"
import { useNavigate } from "react-router-dom"
import styles from "./styles"

export type DataTableRow = {
  _id: string
  name: string
  channelId: string
  status: string
  createdDate: string
}

export default function WhatsappDataTable() {
  const {
    translate,
    isLoading,
    whatsappData: data,
    setPagination,
    setSearch,
    pagination
  } = useWhatsappPageContext()

  const navigate = useNavigate()

  function handleCompanyClick(id: string) {
    navigate(`/whatsapp/${id}`)
  }
  const fieldWidth = 200

  const columns: GridColDef[] = [
    {
      field: "name",
      description: "fixed",
      minWidth: fieldWidth,
      headerName: translate("display_name"),
      renderHeader: () => (
        <Box sx={styles.headerItems}>{translate("display_name")}</Box>
      ),
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box
            sx={styles.renderCellIconBox}
            onClick={() => handleCompanyClick(params.id as string)}
          >
            {params.value}
          </Box>
        )
      },
      sortable: true,
      disableColumnMenu: true
    },
    {
      field: "phone",
      minWidth: fieldWidth,
      headerName: translate("phone"),
      renderHeader: () => (
        <Box sx={styles.headerItems}>{translate("phone")}</Box>
      ),
      renderCell: (params: GridRenderCellParams) => (
        <Box>{params.row.channelId}</Box>
      ),
      disableColumnMenu: true
    },
    {
      field: "status",
      minWidth: fieldWidth,
      headerName: translate("status"),
      renderHeader: () => (
        <Box sx={styles.headerItems}>{translate("status")}</Box>
      ),
      renderCell: (params: GridRenderCellParams) => {
        const value = params.value ? String(params.value) : ""
        return (
          <Box
            sx={{
              color: value ? WATSAPP_ACTIVE : GRAY_COLOR,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis"
            }}
          >
            {value ? translate("approved") : translate("waiting_for_approved")}
          </Box>
        )
      },
      sortable: true,
      disableColumnMenu: true
    },
    {
      field: "company",
      minWidth: fieldWidth,
      headerName: translate("company"),
      renderHeader: () => (
        <Box sx={styles.headerItems}>{translate("company")}</Box>
      ),
      renderCell: (params: GridRenderCellParams) => (
        <Box>{params.row.customer.companyName}</Box>
      ),
      disableColumnMenu: true
    },

    {
      field: "createdAt",
      minWidth: fieldWidth,
      headerName: translate("created_date"),
      renderHeader: () => (
        <Box sx={styles.headerItems}>{translate("created_date")}</Box>
      ),
      renderCell: (params: GridRenderCellParams) => (
        <Box>
          {formatDate(translate("date_format"), params.value as string)}
        </Box>
      ),
      disableColumnMenu: true,
      flex: 1,
      align: "right",
      headerAlign: "right"
    },
    {
      field: "rightIcon",
      minWidth: 100,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      flex: 1,
      align: "right",
      headerAlign: "right"
    }
  ]

  return (
    <Stack sx={{ overflow: "hidden", height: "100%", p: 2 }}>
      <DataTableToolbar onSearch={setSearch} />
      <GridTable
        sortable
        loading={isLoading}
        rows={data as unknown as DataTableRow[]}
        columns={columns}
        rowCount={(data as unknown as DataTableRow[])?.length}
        defaultPageModel={pagination}
        onPaginationModelChange={setPagination}
        getRowId={(row: DataTableRow) => row._id}
        disableColumnSelector={true}
      />
    </Stack>
  )
}
